import React, { useState } from 'react';
import './FullWordList.css';

const FullWordList = ({ words, onWordSelect }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const wordsPerPage = 100;
  const totalPages = Math.ceil(words.length / wordsPerPage);

  // Get current words for the current page
  const indexOfLastWord = currentPage * wordsPerPage;
  const indexOfFirstWord = indexOfLastWord - wordsPerPage;
  const currentWords = words.slice(indexOfFirstWord, indexOfLastWord);

  return (
    <div className="full-word-list">
      <h2 className="word-list-heading">Full word list</h2>
      <div className="word-list-content">
        {currentWords.map((word) => (
          <button 
            key={word}
            onClick={() => onWordSelect(word)}
            className="word-link"
          >
            {word}
          </button>
        ))}
      </div>
      {totalPages > 1 && (
        <div className="pagination">
          <button 
            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            className="pagination-button"
          >
            Previous
          </button>
          <span className="page-info">
            Page {currentPage} of {totalPages}
          </span>
          <button 
            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
            className="pagination-button"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default FullWordList; 